import { render, staticRenderFns } from "./editApplyRoomDiscount.vue?vue&type=template&id=92f917b6&scoped=true"
import script from "./editApplyRoomDiscount.vue?vue&type=script&lang=js"
export * from "./editApplyRoomDiscount.vue?vue&type=script&lang=js"
import style0 from "./editApplyRoomDiscount.vue?vue&type=style&index=0&id=92f917b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f917b6",
  null
  
)

export default component.exports